import React, { useState } from "react"
import Dropdown from "../../../../components/atoms/Dropdown.atom"
import { CLOSE_TYPES } from "../../../../consts/modules/clientReport.consts"

const SPRINT_FILTER_OPTIONS = [
  { label: "Sprints", value: CLOSE_TYPES.NORMAL },
  { label: "Time outs", value: CLOSE_TYPES.TIMEOUT },
]

const SprintsFilter = ({ options }) => {
  const [panelTarget, setPanelTarget] = useState(null)
  return (
    <>
      <Dropdown
        value={options.value}
        options={SPRINT_FILTER_OPTIONS}
        onChange={(e) => {
          options.filterCallback(e.value)
        }}
        optionLabel="label"
        optionValue="value"
        placeholder="Filtrar sprint"
        appendTo={panelTarget}
      />
      <div ref={setPanelTarget}></div>
    </>
  )
}

export const SPRINT_FILTER_PROPS = {
  filter: true,
  filterField: "closeType",
  filterMatchMode: "equals",
  filterElement: (options) => <SprintsFilter options={options} />,
  showFilterMatchModes: false,
  showFilterMenuOptions: false,
  filterMenuClassName: "history-sprints-filter",
}

export default SprintsFilter
